import { createRouter, createWebHashHistory } from 'vue-router'
import { useAuthStore } from '../stores/auth'
import { useSubscriptionStore } from '../stores/subscription'
import api, { adminApi } from '@/api'

const router = createRouter({
  history: createWebHashHistory(),
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('../views/HomeView.vue'),
      meta: { requiresAuth: true, title: 'Dashboard' }
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('../views/auth/Login.vue'),
      meta: { requiresAuth: false }
    },
    {
      path: '/reset-password',
      name: 'reset-password',
      component: () => import('../views/auth/ResetPassword.vue'),
      meta: { requiresAuth: false }
    },
    {
      path: '/branches',
      name: 'branches',
      component: () => import('../views/branches/BranchListView.vue'),
      meta: { requiresAuth: true, title: 'Şubeler' }
    },
    {
      path: '/kiosk',
      name: 'kiosk',
      component: () => import('../views/kiosk/KioskView.vue'),
      meta: { requiresAuth: true, title: 'QR Kiosk' }
    },
    {
      path: '/kiosk/display',
      name: 'kiosk-display',
      component: () => import('../views/kiosk/KioskView.vue'),
      meta: { requiresAuth: true, title: 'QR Kiosk', hideLayout: true }
    },
    {
      path: '/employees',
      name: 'employees',
      component: () => import('../views/employees/EmployeeListView.vue'),
      meta: { requiresAuth: true, title: 'Personeller' }
    },
    {
      path: '/employee-import',
      name: 'employee-import',
      component: () => import('../views/employees/BulkImportView.vue'),
      meta: {
        requiresAuth: true,
        title: 'Personel İçe Aktarma'
      }
    },
    {
      path: '/employee-hire-resign',
      name: 'employee-hire-resign',
      component: () => import('../views/employees/EmployeeHireResignView.vue'),
      meta: {
        requiresAuth: true,
        title: 'Personel Hareketleri'
      }
    },
    {
      path: '/birthdays',
      name: 'birthdays',
      component: () => import('../views/employees/BirthdaysView.vue'),
      meta: {
        requiresAuth: true,
        title: 'Doğum Günleri'
      }
    },
    {
      path: '/profile/edit',
      name: 'profile-edit',
      component: () => import('../views/profile/ProfileEditView.vue'),
      meta: {
        requiresAuth: true,
        title: 'Profil Düzenle'
      }
    },
    {
      path: '/change-password',
      name: 'change-password',
      component: () => import('../views/profile/ChangePasswordView.vue'),
      meta: {
        requiresAuth: true,
        title: 'Şifre Değiştir'
      }
    },
    {
      path: '/suspicious-activities',
      name: 'suspicious-activities',
      component: () => import('../views/suspicious-activities/SuspiciousActivitiesView.vue'),
      meta: {
        requiresAuth: true,
        title: 'Şüpheli İşlemler'
      }
    },
    {
      path: '/reports/monthly-summary',
      name: 'monthly-summary',
      component: () => import('../views/reports/MonthlySummaryReport.vue'),
      meta: { requiresAuth: true, title: 'Aylık Özet Raporu' }
    },
    {
      path: '/reports/monthly-time',
      name: 'monthly-time',
      component: () => import('../views/reports/MonthlyTimeReport.vue'),
      meta: { requiresAuth: true, title: 'Aylık Giriş-Çıkış Raporu' }
    },
    {
      path: '/reports/daily-attendance',
      name: 'daily-attendance',
      component: () => import('../views/reports/DailyAttendanceReport.vue'),
      meta: { requiresAuth: true, title: 'Günlük Çalışma Raporu' }
    },
    {
      path: '/reports/leave-balance',
      name: 'leave-balance',
      component: () => import('../views/reports/leave-balance/LeaveBalanceReport.vue'),
      meta: { requiresAuth: true, title: 'İzin Bakiye Raporu' }
    },
    {
      path: '/reports/absence',
      name: 'absence-report',
      component: () => import('../views/reports/absence/AbsenceReport.vue'),
      meta: { requiresAuth: true, title: 'İzin Yokluk Raporu' }
    },
    {
      path: '/reports/holiday-work-compensation',
      name: 'holiday-work-compensation-report',
      component: () => import('../views/reports/HolidayWorkCompensationReport.vue'),
      meta: { requiresAuth: true, title: 'Tatil Çalışması Hakedişi Raporu' }
    },
    {
      path: '/subscription',
      name: 'subscription',
      component: () => import('../views/subscription/SubscriptionView.vue'),
      meta: { requiresAuth: true, title: 'Abonelik' }
    },
    {
      path: '/kvkk-consents',
      name: 'kvkk-consents',
      component: () => import('../views/kvkk/KvkkConsentsView.vue'),
      meta: { requiresAuth: true, title: 'KVKK Onayları' }
    },
    {
      path: '/leave-requests-list',
      name: 'leave-requests-list',
      component: () => import('../views/leaves/LeaveRequestListView.vue'),
      meta: { requiresAuth: true, title: 'İzin Talepleri' }
    },
    {
      path: '/leave-types',
      name: 'leave-types',
      component: () => import('../views/leaves/LeaveTypeListView.vue'),
      meta: { requiresAuth: true, title: 'İzin Tipleri' }
    },
    {
      path: '/shifts',
      name: 'shifts',
      component: () => import('../views/shifts/ShiftsManagementView.vue'),
      meta: { requiresAuth: true, title: 'Vardiya Listesi' }
    },
    {
      path: '/shift-rotations',
      name: 'shift-rotations',
      component: () => import('../views/shifts/ShiftRotations.vue'),
      meta: { requiresAuth: true, title: 'Vardiya Rotasyonları' }
    },
    {
      path: '/shift-employee-management',
      name: 'shift-employee-management',
      component: () => import('../views/shifts/ShiftEmployeeManagementView.vue'),
      meta: { requiresAuth: true, title: 'Vardiya Personel Yönetimi' }
    },
    {
      path: '/shift-calendar',
      name: 'shift-calendar',
      component: () => import('../views/shifts/ShiftCalendarView.vue'),
      meta: { requiresAuth: true, title: 'Vardiya Takvimi' }
    },
    {
      path: '/daily-shift-planning',
      name: 'daily-shift-planning',
      component: () => import('../views/shifts/DailyShiftPlanningView.vue'),
      meta: { requiresAuth: true, title: 'Gunluk Vardiya Planlama' }
    },
    {
      path: '/leave-planning',
      name: 'leave-planning',
      component: () => import('../views/leave-planning/LeavePlanningView.vue'),
      meta: { requiresAuth: true, title: 'İzin Planlama' }
    },
    {
      path: '/leave-planning/calendar',
      name: 'leave-planning-calendar',
      component: () => import('../views/leave-planning/LeavePlanningCalendarView.vue'),
      meta: { requiresAuth: true, title: 'İzin Planlama Takvimi' }
    },
    {
      path: '/leave-entitlements',
      name: 'leave-entitlements',
      component: () => import('../views/leaves/LeaveEntitlementsView.vue'),
      meta: { requiresAuth: true, title: 'İzin Hakedişleri' }
    },
    {
      path: '/day-off-change',
      name: 'day-off-change',
      component: () => import('../views/leaves/DayOffChangeRequestView.vue'),
      meta: { requiresAuth: true, title: 'İzin Değişikliği Talepleri' }
    },
    {
      path: '/payment',
      name: 'payment',
      component: () => import('../views/payment/PaymentResultView.vue'),
      meta: { requiresAuth: false }
    },
    {
      path: '/payment/success',
      name: 'paymentSuccess',
      component: () => import('../views/payment/PaymentResultView.vue'),
      meta: { requiresAuth: false, isSuccess: true }
    },
    {
      path: '/payment/fail',
      name: 'paymentFail',
      component: () => import('../views/payment/PaymentResultView.vue'),
      meta: { requiresAuth: false, isSuccess: false }
    },
    {
      path: '/payment/result',
      name: 'paymentResult',
      component: () => import('../views/payment/PaymentResultView.vue'),
      meta: { requiresAuth: false }
    },
    {
      path: '/payment/credit-card',
      name: 'creditCardPayment',
      component: () => import('../views/payment/CreditCardPaymentView.vue'),
      meta: { requiresAuth: false }
    },
    {
      path: '/advance-requests-list',
      name: 'advance-requests-list',
      component: () => import('../views/advances/AdvanceRequestListView.vue'),
      meta: { requiresAuth: true, title: 'Avans Talepleri' }
    },
    {
      path: '/activity-list',
      name: 'activity-list',
      component: () => import('../views/activity/ActivityListView.vue'),
      meta: { requiresAuth: true, title: 'Aktiviteler' }
    },
    {
      path: '/events',
      name: 'events',
      component: () => import('../views/events/EventsCalendarView.vue'),
      meta: { requiresAuth: true, title: 'Etkinlik Takvimi' }
    },
    {
      path: '/assets',
      name: 'assets',
      component: () => import('../views/assets/AssetsView.vue'),
      meta: { requiresAuth: true, title: 'Zimmet Yönetimi' }
    },
    {
      path: '/faults',
      name: 'faults',
      component: () => import('../views/assets/FaultsView.vue'),
      meta: { requiresAuth: true, title: 'Arıza Kayıtları' }
    },
    {
      path: '/upcoming-maintenance',
      name: 'upcoming-maintenance',
      component: () => import('../views/assets/UpcomingMaintenanceView.vue'),
      meta: { requiresAuth: true, title: 'Yaklaşan Bakımlar' }
    },
    {
      path: '/leave-balance-management',
      name: 'leave-balance-management',
      component: () => import('../views/leaves/LeaveBalanceManagement.vue'),
      meta: { requiresAuth: true, title: 'İzin Bakiye Yönetimi' }
    },
    {
      path: '/leave-balance-by-type',
      name: 'leave-balance-by-type',
      component: () => import('../views/leaves/LeaveBalanceByTypeView.vue'),
      meta: { requiresAuth: true, title: 'İzin Türüne Göre Bakiye' }
    },
    {
      path: '/settings',
      name: 'settings',
      component: () => import('../views/settings/Settings.vue'),
      meta: { requiresAuth: true, title: 'Ayarlar' }
    },
    {
      path: '/roles-permissions',
      name: 'roles-permissions',
      component: () => import('../views/roles/RolesPermissionsView.vue'),
      meta: { requiresAuth: true, title: 'Roller ve İzinler' }
    },
    {
      path: '/suggestions',
      name: 'suggestions',
      component: () => import('../views/suggestions/SuggestionsView.vue'),
      meta: { requiresAuth: true, title: 'Fikir ve Öneriler' }
    },
    {
      path: '/procedures',
      name: 'procedures',
      component: () => import('../views/procedures/ProceduresView.vue'),
      meta: { requiresAuth: true, title: 'Prosedürler' }
    },
    {
      path: '/departments',
      name: 'departments',
      component: () => import('@/views/departments/DepartmentsView.vue'),
      meta: { requiresAuth: true, title: 'Departmanlar' }
    },
    {
      path: '/departments/employees',
      name: 'department-employees',
      component: () => import('@/views/departments/DepartmentsView.vue'),
      meta: { requiresAuth: true, title: 'Departman Personelleri' }
    },
    {
      path: '/leave-balance-import',
      name: 'leave-balance-import',
      component: () => import('../views/leaves/LeaveBalanceImportView.vue'),
      meta: { requiresAuth: true, title: 'İzin Bakiye Aktarımı' }
    },
    {
      path: '/leave-usage-movements',
      name: 'leave-usage-movements',
      component: () => import('../views/leaves/LeaveUsageMovementsView.vue'),
      meta: { requiresAuth: true, title: 'İzin Kullanım Hareketleri' }
    },
    {
      path: '/notifications',
      name: 'notifications',
      component: () => import('../views/notifications/NotificationListView.vue'),
      meta: { requiresAuth: true, title: 'Bildirimler' }
    },
    {
      path: '/users',
      name: 'users',
      component: () => import('../views/users/UserListView.vue'),
      meta: { requiresAuth: true, title: 'Kullanıcılar' }
    },
    {
      path: '/holidays',
      name: 'holidays',
      component: () => import('../views/holidays/HolidaysView.vue'),
      meta: { requiresAuth: true, title: 'Tatiller' }
    },
    {
      path: '/daily-menu',
      name: 'daily-menu',
      component: () => import('../views/daily-menu/DailyMenuView.vue'),
      meta: { requiresAuth: true, title: 'Günlük Yemek Menüsü' }
    },
    {
      path: '/reports/dinner-card',
      name: 'dinner-card-report',
      component: () => import('../views/reports/dinner-card/DinnerCardReport.vue'),
      meta: { requiresAuth: true, title: 'Yemek Kartı Raporu' }
    },
    {
      path: '/reports/overtime',
      name: 'overtime-report',
      component: () => import('../views/reports/OvertimeReport.vue'),
      meta: { requiresAuth: true, title: 'Mesai Raporu' }
    },
    {
      path: '/reports/employee-status',
      name: 'employee-status-report',
      component: () => import('../views/reports/EmployeeStatusReportView.vue'),
      meta: { requiresAuth: true, title: 'Personel Durum Raporu' }
    },
    {
      path: '/branch-assignments',
      name: 'branch-assignments',
      component: () => import('../views/branch-assignments/BranchAssignmentsView.vue'),
      meta: { requiresAuth: true, title: 'Şube Görevlendirmeleri' }
    },
    {
      path: '/duty-periods',
      name: 'duty-periods',
      component: () => import('../views/duty-periods/DutyPeriodsView.vue'),
      meta: { requiresAuth: true, title: 'Görevli Zamanlar' }
    },
    {
      path: '/devices',
      name: 'devices',
      component: () => import('../views/devices/DeviceListView.vue'),
      meta: { requiresAuth: true, title: 'Kayıtlı Cihazlar' }
    },
    {
      path: '/break-types',
      name: 'break-types',
      component: () => import('../views/settings/BreakTypesView.vue'),
      meta: { requiresAuth: true, title: 'Mola Tipleri' }
    },
    {
      path: '/beacons',
      name: 'beacons',
      component: () => import('../views/settings/BeaconsView.vue'),
      meta: { requiresAuth: true, title: 'Beacon Cihazları' }
    },
    // Servis Taşımacılığı
    {
      path: '/service-routes',
      name: 'service-routes',
      component: () => import('../views/service-transport/ServiceRoutesView.vue'),
      meta: { requiresAuth: true, title: 'Servis Güzergahları' }
    },
    {
      path: '/service-vehicles',
      name: 'service-vehicles',
      component: () => import('../views/service-transport/ServiceVehiclesView.vue'),
      meta: { requiresAuth: true, title: 'Servis Araçları' }
    },
    {
      path: '/service-assignments',
      name: 'service-assignments',
      component: () => import('../views/service-transport/ServiceAssignmentsView.vue'),
      meta: { requiresAuth: true, title: 'Servis Atamaları' }
    },
    {
      path: '/reports/breaks',
      name: 'breaks-report',
      component: () => import('../views/reports/BreaksReportView.vue'),
      meta: { requiresAuth: true, title: 'Mola Hareketleri' }
    },
    {
      path: '/reports/break-summary',
      name: 'break-summary-report',
      component: () => import('../views/reports/BreakSummaryReport.vue'),
      meta: { requiresAuth: true, title: 'Mola Özet Raporu' }
    },
    {
      path: '/reports/employee-monthly-attendance',
      name: 'employee-monthly-attendance',
      component: () => import('../views/reports/EmployeeMonthlyAttendanceReport.vue'),
      meta: { requiresAuth: true, title: 'Personel Aylık Giriş-Çıkış Raporu' }
    },
    {
      path: '/reports/weekly-employee-attendance',
      name: 'weekly-employee-attendance',
      component: () => import('../views/reports/WeeklyEmployeeAttendanceReport.vue'),
      meta: { requiresAuth: true, title: 'Haftalık Personel Çalışma Raporu' }
    },
    {
      path: '/reports/daily-work-hours',
      name: 'daily-work-hours',
      component: () => import('../views/reports/DailyWorkHoursReport.vue'),
      meta: { requiresAuth: true, title: 'Günlük Çalışma Saati Raporu' }
    },
    {
      path: '/reports/daily-all-employees-work-hours',
      name: 'daily-all-employees-work-hours',
      component: () => import('../views/reports/DailyAllEmployeesWorkHoursReport.vue'),
      meta: { requiresAuth: true, title: 'Günlük Tüm Personel Çalışma Saati Raporu' }
    },
    {
      path: '/profile/edit',
      name: 'profile-edit',
      component: () => import('../views/profile/ProfileEditView.vue'),
      meta: { requiresAuth: true, title: 'Profil Düzenle' }
    },
    {
      path: '/manual-entry-requests',
      name: 'manual-entry-requests',
      component: () => import('../views/manual-entry-requests/ManualEntryRequestsView.vue'),
      meta: { requiresAuth: true, title: 'Manuel Giriş Talepleri' }
    }
  ]
})

router.beforeEach(async (to, from, next) => {
  const authStore = useAuthStore()
  const subscriptionStore = useSubscriptionStore()
  const isLoggedIn = authStore.isAuthenticated()

  // Kiosk display'den geri/başka sayfaya gidilmesini engelle: panel hiç görünmesin, doğrudan login
  if (from.path === '/kiosk/display' && to.path !== '/login') {
    next(false) // bu yönlendirmeyi iptal et
    authStore.logout() // oturumu kapat ve login'e push eder
    return
  }

  // Kiosk rolündeki kullanıcı sadece /kiosk ve /kiosk/display görebilir
  if (isLoggedIn && authStore.user?.is_kiosk_user && to.path !== '/kiosk' && to.path !== '/kiosk/display') {
    next('/kiosk')
    return
  }

  // Hash routing'de /payment#/ durumunu kontrol et
  if (window.location.hash === '#/' && to.path === '/') {
    // URL'de tam olarak /payment varsa payment sayfasına yönlendir
    if (window.location.pathname === '/payment') {
      next('/payment');
      return;
    }
  }
  
  // URL'de /payment varsa ama router / olarak algılıyorsa
  if (to.path === '/' && window.location.pathname === '/payment') {
    next('/payment');
    return;
  }
  
  // Ödeme sayfaları için her zaman geç
  if (to.path.startsWith('/payment/') || to.path === '/payment') {
    next();
    return;
  }
  
  // Oturum gerektiren rotalar için kontrol
  if (to.meta.requiresAuth && !isLoggedIn) {
    next('/login')
    return
  }
  
  // Abonelik kontrolü - kiosk rolündeki kullanıcılar kısıtlama olmadan devam eder
  if (isLoggedIn && to.meta.requiresAuth && authStore.user?.is_kiosk_user) {
    next()
    return
  }

  // Abonelik kontrolü - tüm authenticated rotalar için (kiosk hariç)
  if (isLoggedIn && to.meta.requiresAuth) {
    try {
      // Eğer subscription store'da isActive bilgisi zaten varsa, onu kullan
      if (subscriptionStore.isActive !== undefined && subscriptionStore.subscriptionData?.id) {
        const isActive = subscriptionStore.isActive

        if (!isActive) {
          subscriptionStore.checkAndSetExpirationModal()
        }
      } else {
        // Admin-API'den abonelik bilgisini al (güvenli kontrol)
        const response = await adminApi.get(`/subscriptions/company/${authStore.user.id}`)
        const subscription = response.data
        
        if (subscription && subscription.id) {
          const endDateOk = new Date(subscription.end_date) > new Date()
          const hasGrace = subscription.has_unpaid_order_with_future_date === true
          const isActive = (subscription.status === 'active' && endDateOk) || hasGrace

          // Store'a kaydet
          subscriptionStore.setSubscriptionStatus(isActive)
          subscriptionStore.setSubscriptionData(subscription)
          subscriptionStore.checkAndSetExpirationModal()
        } else {
          subscriptionStore.setSubscriptionStatus(false)
          subscriptionStore.setShowExpirationModal(true)
        }
      }
    } catch (error) {
      console.error('Abonelik kontrolü sırasında hata (Admin-API):', error)
      // Admin-API'ye ulaşılamıyorsa, güvenlik nedeniyle aboneliği pasif say
      subscriptionStore.setSubscriptionStatus(false)
      subscriptionStore.setShowExpirationModal(true)
    }
  }
  
  // Personel / personel KVKK akışları: şirket seviyesi KVKK tamamlanma kontrolüne tabi tutulmaz
  // (company-status çoklu telefon satırlarında hasAllConsents'ı yanlış düşürebilir; yönlendirme gereksiz)
  const skipCompanyKvkkRedirect =
    to.path === '/kvkk-consents' ||
    ['/employees', '/employee-import', '/employee-hire-resign', '/birthdays', '/departments/employees'].some(
      (p) => to.path === p || to.path.startsWith(`${p}/`),
    )

  // KVKK consent kontrolü - sadece TR için (labor_law_country === 'tr')
  // authenticated kullanıcılar için; personel sayfaları ve KVKK ekranı hariç
  if (isLoggedIn && to.meta.requiresAuth && !skipCompanyKvkkRedirect) {
    try {
      // Önce şirket ayarlarını kontrol et
      const settingsResponse = await api.get('/settings')
      const settings = settingsResponse.data
      
      // Sadece labor_law_country 'tr' ise KVKK kontrolü yap
      if (settings && settings.labor_law_country === 'tr') {
        const consentResponse = await api.get('/kvkk-consent/company-status')
        const consentData = consentResponse.data
        
        // Eğer tüm KVKK formları onaylanmamışsa /kvkk-consents sayfasına yönlendir
        if (consentData && consentData.hasAllConsents === false) {
          next('/kvkk-consents')
          return
        }
      }
    } catch (error) {
      // KVKK consent kontrolü sırasında hata oluşursa devam et
      console.error('KVKK/Settings kontrolü sırasında hata:', error)
    }
  }
  
  next()
})

export default router 